import React from 'react';
import { LinkWithGAClickButton, ReviewsBenefits, ReviewsCatalog, ReviewsSection, Typography } from 'common/components';
import {
  newKitchenReviewsBenefits,
  newKitchenReviewsLink,
} from './new-kitchen-reviews-styles';
import { KITCHEN_ELEMENT_BLOCK, KITCHEN_SIGN_UP_HREF } from '../../../kitchen-constants';
import { NEW_KITCHEN_REVIEWS_BENEFITS_DATA, NEW_KITCHEN_REVIEWS_DATA } from './new-kitchen-reviews-constants';

type NewKitchenReviewsProps = {
  regionId: string;
};

export const NewKitchenReviews: React.FC<NewKitchenReviewsProps> = ({ regionId }) => (
  <ReviewsSection
    benefits={
      <ReviewsBenefits benefitsList={NEW_KITCHEN_REVIEWS_BENEFITS_DATA} className={newKitchenReviewsBenefits} />
    }
    description="Делаем кухни, которые хочется показывать"
    review={
      <ReviewsCatalog
        elementBlock={KITCHEN_ELEMENT_BLOCK}
        reviewsList={NEW_KITCHEN_REVIEWS_DATA}
      />
    }
    title={<>
      <LinkWithGAClickButton
        className={newKitchenReviewsLink}
        elementBlock={`${KITCHEN_ELEMENT_BLOCK} / Reviews`}
        elementName="Отзывы клиентов"
        elementText="Запишитесь"
        title="Запишитесь на проектирование"
        href={`${KITCHEN_SIGN_UP_HREF}${regionId}`}
        target="_blank">
        <Typography variant="h2" color="text-invert">
          Запишитесь
        </Typography>
      </LinkWithGAClickButton>{' '}
      на&nbsp;бесплатное проектирование, <span>а&nbsp;мы&nbsp;позаботимся о&nbsp;всех этапах!</span>
    </>
    }
  />
);
